import { useCallback, useEffect } from 'react';
import styles from './index.module.sass';
import hint from 'images/hint_error.svg';
import classnames from 'classnames/bind';
import Button from 'components/button';
const cx = classnames.bind(styles);

const ErrorDialog = props => {
  const { show, onClose, plateNumberAlreadyExistsErrorMessage, plateNumber, couponCode, mobile, errorCode } = props;

  const closeMask = useCallback(
    e => {
      if (e.key === 'Escape') onClose();
    },
    [onClose]
  );

  useEffect(() => {
    window.addEventListener('keydown', closeMask);
    return () => {
      window.removeEventListener('keydown', closeMask);
    };
  }, [closeMask]);

  const errorMessage = () => {
    switch (errorCode) {
      case 'coupon_old_code_error':
        return '輸入的序號不正確！';
      case 'coupon_old_not_found':
        return `序號 ${couponCode} 無效`;
      case 'coupon_old_code_been_used':
        return `序號 ${couponCode} 已被使用`;
      case 'plate_number_format_error':
        return '車牌格式錯誤！';
      case 'plate_number_is_moto':
        return '優惠領取限填汽車車牌';
      case 'plate_number_already_exists':
        return plateNumberAlreadyExistsErrorMessage;
      case 'plate_number_not_belong_to_member':
        return `車牌 ${plateNumber} 尚未綁定於此會員手機上`;
      case 'coupon_is_not_available':
      case 'coupon_old_is_not_available':
        return '活動尚未開始喔！<br/>請密切注意活動消息。';
      case 'coupon_is_expired':
      case 'coupon_old_is_expired':
        return '本次活動已結束囉！<br/>下次活動歡迎繼續參與。';
      case 'plate_number_is_not_member':
        return '此車牌尚未設定於車麻吉';
      case 'quantity_exceeded':
        return '序號已達兌換上限';
      case 'member_need_login':
        return '此會員手機尚未註冊於車麻吉';
      case 'promotion_verification_target_error':
        return `${mobile} 尚未註冊會員，無法領取此優惠`;
      case 'used_count_limit_exceeded':
        return '您已經兌換過此優惠，無法重複領取';
      case 'promotion_verification_is_not_available':
        return '優惠尚未開始發放';
      case 'promotion_verification_not_found':
      case 'promotion_verification_disabled':
        return '找不到優惠資格';
      case 'promotion_verification_is_expired':
        return '優惠已結束發放';
      case 'promotion_certificate_exceed':
        return '限量優惠已發放完畢';
      default:
        return '發生未知的錯誤';
    }
  };

  const maskClass = cx({
    mask: true,
    show,
  });

  return (
    <div className={maskClass} onClick={onClose}>
      <div className={styles.content}>
        <div className={styles.close} onClick={onClose} />
        <div className={styles.hint}>
          <img src={hint} alt="hint" />
        </div>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: errorMessage() }} />
        <Button onClick={onClose}>我知道了</Button>
      </div>
    </div>
  );
};

export default ErrorDialog;
